<template>
  <div class="content">
    <div class="thehome">
      <span @click="topath('/')">{{ $t("header.home") }} </span>&nbsp;/
    </div>
    <div class="one">
      <span>{{ $t("header.information") }}</span>
    </div>
    <informations
      :ani="state.d3"
      :informationlist="state.formationlist"
    ></informations>
    <div
      class="readmore"
      v-if="state.readmore"
      @click="readmore(state.perpage)"
    >
      {{ $t("header.Load_more") }}
    </div>
  </div>
</template>

<script setup>
import { reactive, onMounted } from "vue";
import informations from "@/components/informations.vue";
import { newslist } from "@/api/type";
import { useRouter } from "vue-router";
const router = useRouter();
const state = reactive({
  d3: false,
  dsd: true,
  readmore: true,
  page: 1,
  perpage: 4,
  formationlist: [
    // {
    //   img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
    //   title: "2023 年行业聚迟行业聚焦推迟",
    //   detail:
    //     "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
    //   data: "2023.09.13",
    //   id: 1,
    // },
    // {
    //   img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
    //   title: "2023 年行业聚焦推迟",
    //   detail:
    //     "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
    //   data: "2023.09.13",
    //   id: 2,
    // },
    // {
    //   img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
    //   title: "2023 年行业聚焦推迟行业聚焦推迟行业聚焦推迟",
    //   detail:
    //     "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
    //   data: "2023.09.13",
    //   id: 3,
    // },
    // {
    //   img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
    //   title: "2023 年行业聚焦推迟",
    //   detail:
    //     "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
    //   data: "2023.09.13",
    //   id: 4,
    // },
    // {
    //   img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
    //   title: "2023 年行业聚焦推迟行业聚焦推迟行业聚焦推迟",
    //   detail:
    //     "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
    //   data: "2023.09.13",
    //   id: 5,
    // },
    // {
    //   img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
    //   title: "2023 年行业聚焦推迟",
    //   detail:
    //     "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
    //   data: "2023.09.13",
    //   id: 6,
    // },
    // {
    //   img: "https://bunseninstitute.oss-cn-hangzhou.aliyuncs.com/files/images/ralf-leineweber-sRMzAdjWK_E-unsplash_%E7%9C%8B%E5%9B%BE%E7%8E%8B(1).jpg",
    //   title: "2023 年行业聚焦推迟行业聚焦推迟行业聚焦推迟",
    //   detail:
    //     "我们将讨论我们使用深度学习来创建可以生成艺术（草图和音乐）的方法的工作，并在创建这些工...",
    //   data: "2023.09.13",
    //   id: 7,
    // },
  ],
});
newslist({
  page: state.page,
  perPage: state.perpage,
}).then((res) => {
  state.formationlist = res.data;
});

const handleScroll = () => {
  const scrollY = window.scrollY || window.pageYOffset;
  // console.log(scrollY, 989898);
  if (scrollY > 0) {
    state.d3 = true;
  }
};

const readmore = (e) => {
  // console.log(e,123);
  state.perpage += 2;
  newslist({
    page: state.page,
    perPage: state.perpage,
  }).then((res) => {
    state.formationlist = res.data;
    if (state.formationlist.length == res.meta.total) {
      state.readmore = false;
    }
  });
};
const topath = (e) => {
  router.push(e);
};
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
  // state.d3 = true;
  // setTimeout(() => {
  //   state.d3 = true;

  state.d3 = false;
  setTimeout(() => {
    state.d3 = true;
  }, 3330); // 等待 50ms
  requestAnimationFrame(() => {
    state.d3 = true;
  });
  // }, 100);
  const scrollY = window.scrollY || window.pageYOffset;
  // console.log(scrollY, 989898);
  if (scrollY > 0) {
    state.d3 = true;
  }
});
</script>

<style lang="scss" scoped>
@import "@/sass/index.scss";
.content {
  .thehome {
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    // height: 500px;
    position: relative;
    padding: 68px 0 0 0;
    text-align: left;
    margin-bottom: 80px;
  }
  .one {
    text-align: center;
    display: inline-block;
    @include fontstyle(#333, 40px, 800, auto);
    line-height: 47px;
    margin-bottom: 48px;
    border-bottom: 8px solid #f4775e;
    padding-bottom: 3px;
  }
  .readmore {
    padding: 10px 20px;
    cursor: pointer;
    background: #4a53d7;
    color: #fff;
    display: inline-block;
    margin-bottom: 80px;
    border-radius: 4px;
  }
}
@media screen and (max-width: 1200px) {
  .content {
    padding: 30px;
  }
}
</style>
